module.exports = __webpack_public_path__ + "static/img/field@2x.8b001dbc.png";